"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[501],{

/***/ 20614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgPort = function SvgPort(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 32"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M17.285 14.728a.188.188 0 0 0-.144-.067h-2.349a.215.215 0 0 0-.198.132l-.001.001a.199.199 0 0 0 .001.241v-.001l.669.669a3.626 3.626 0 0 1-1.238 1.008l-.021.009a5.587 5.587 0 0 1-1.779.546l-.029.003v-4.338h1.286a.415.415 0 0 0 .415-.415v-.014.001-.859a.411.411 0 0 0-.121-.292.44.44 0 0 0-.303-.121h-1.237v-1.098c.257-.151.465-.359.612-.608l.004-.008c.143-.231.228-.511.228-.811l-.001-.049v-.031c0-.46-.19-.875-.495-1.172-.309-.306-.735-.495-1.205-.495s-.896.189-1.205.495a1.628 1.628 0 0 0-.496 1.172v.035-.002l-.001.046c0 .3.085.58.232.817l-.004-.007c.151.257.359.465.608.612l.008.004v1.098H9.177a.437.437 0 0 0-.303.121.414.414 0 0 0-.12.292v.873c0 .229.186.415.415.415h.014-.001 1.339v4.311a5.688 5.688 0 0 1-1.84-.564l.033.015a3.628 3.628 0 0 1-1.253-1.01l-.006-.008.669-.669a.199.199 0 0 0-.001-.241v.001a.215.215 0 0 0-.199-.134H5.615a.185.185 0 0 0-.143.067.217.217 0 0 0 .001.149v-.001 2.356l-.001.018c0 .082.057.151.134.169h.014a.187.187 0 0 0 .149-.001h-.001l.629-.616a5.388 5.388 0 0 0 2.079 1.487l.036.013c.847.356 1.832.563 2.865.563s2.018-.207 2.915-.581l-.05.019a5.386 5.386 0 0 0 2.11-1.493l.006-.007.629.616a.204.204 0 0 0 .149 0h-.001.08a.174.174 0 0 0 .135-.17l-.001-.019v.001-2.357a.211.211 0 0 0-.067-.12zm-5.61-5.757a.412.412 0 0 1-.59 0 .39.39 0 0 1-.134-.294v-.021c0-.115.052-.218.133-.287h.001a.412.412 0 0 1 .59 0 .374.374 0 0 1 .134.287v.022a.387.387 0 0 1-.134.293z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M22.762 11.327C22.732 5.065 17.648 0 11.381 0 5.096 0 0 5.095 0 11.381v.056-.003 4.472a9.444 9.444 0 0 0 1.136 4.482l-.025-.05 9.372 11.113a1.032 1.032 0 0 0 1.818.005l.003-.005 9.372-11.113a9.373 9.373 0 0 0 1.085-4.406v-.027.001zm-2.826 8.288-7.792 9.279a.872.872 0 0 1-1.524.004l-.002-.004-7.792-9.279a7.658 7.658 0 0 1-.937-3.695v-3.722c0-5.275 4.231-10.35 9.493-10.35s9.493 5.034 9.493 10.203v3.866c0 1.355-.347 2.63-.958 3.739l.02-.04z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgPort);

/***/ }),

/***/ 75565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InputWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function InputWrapper(param) {
    var icon = param.icon, actionIcon = param.actionIcon, errorMessage = param.errorMessage, children = param.children, _action = param.action, action = _action === void 0 ? function() {} : _action;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "input-wrapper relative w-full bg-white ".concat(errorMessage ? 'with-errors' : ''),
        children: [
            icon,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative",
                children: children
            }),
            actionIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "group hover:bg-gray-400 cursor-pointer items-center justify-center bg-gray-200 z-20 absolute h-full w-[50px] right-0 top-0 flex",
                onClick: action,
                children: actionIcon
            }),
            errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                className: "error-label absolute px-2 py-1 text-white",
                children: errorMessage
            })
        ]
    }));
};


/***/ }),

/***/ 41125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
module.exports = {
    content: [
        './src/**/*.{js,ts,jsx,tsx}', 
    ],
    theme: {
        screens: {
            sm: '640px',
            md: '768px',
            lg: '1024px',
            xl: '1280px',
            '2xl': '1536px'
        },
        colors: function(param) {
            var colors = param.colors;
            return {
                inherit: colors.inherit,
                current: colors.current,
                transparent: colors.transparent,
                primary: {
                    DEFAULT: '#1C1C58',
                    50: '#898ADA',
                    100: '#7A7BD5',
                    200: '#5B5CCC',
                    300: '#23487D',
                    400: '#3334A2',
                    500: '#1D4E8F',
                    600: '#1C1C58',
                    700: '#0E0F2E',
                    800: '#010103',
                    900: '#000000'
                },
                action: {
                    DEFAULT: '#FBB900',
                    50: '#FFEBB4',
                    100: '#FFE69F',
                    200: '#FFDB76',
                    300: '#FFD04E',
                    400: '#FBC033',
                    500: '#FBB900',
                    600: '#C39000',
                    700: '#8B6600',
                    800: '#533D00',
                    900: '#1B1400'
                },
                secondary: '#ffcd00',
                black: colors.black,
                white: colors.white,
                slate: colors.slate,
                gray: colors.gray,
                gray2: _objectSpread({}, colors.gray, {
                    40: 'rgba(0, 0, 0, 0.4)',
                    50: 'rgba(128, 128, 128, 0.5)',
                    100: '#cbcbcb',
                    200: '#F3F2F2',
                    300: '#333333',
                    900: '#949494'
                }),
                zinc: colors.zinc,
                neutral: colors.neutral,
                stone: colors.stone,
                red: colors.red,
                orange: colors.orange,
                amber: colors.amber,
                yellow: _objectSpread({}, colors.yellow, {
                    100: '#b38f00'
                }),
                lime: colors.lime,
                green: _objectSpread({}, colors.green, {
                    100: '#348f41'
                }),
                emerald: colors.emerald,
                teal: colors.teal,
                cyan: colors.cyan,
                sky: colors.sky,
                blue: _objectSpread({}, colors.blue, {
                    100: '#002453',
                    200: '#000042'
                }),
                indigo: colors.indigo,
                violet: colors.violet,
                purple: colors.purple,
                fuchsia: colors.fuchsia,
                pink: colors.pink,
                rose: colors.rose,
                adac: {
                    fg: 'rgba(255, 207, 1, 1)',
                    bg: '#2b2d30'
                }
            };
        },
        columns: {
            auto: 'auto',
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            10: '10',
            11: '11',
            12: '12',
            '3xs': '16rem',
            '2xs': '18rem',
            xs: '20rem',
            sm: '24rem',
            md: '28rem',
            lg: '32rem',
            xl: '36rem',
            '2xl': '42rem',
            '3xl': '48rem',
            '4xl': '56rem',
            '5xl': '64rem',
            '6xl': '72rem',
            '7xl': '80rem'
        },
        spacing: {
            px: '1px',
            0: '0px',
            0.5: '0.125rem',
            1: '0.25rem',
            1.5: '0.375rem',
            2: '0.5rem',
            2.5: '0.625rem',
            3: '0.75rem',
            3.5: '0.875rem',
            4: '1rem',
            5: '1.25rem',
            6: '1.5rem',
            7: '1.75rem',
            8: '2rem',
            9: '2.25rem',
            10: '2.5rem',
            11: '2.75rem',
            12: '3rem',
            14: '3.5rem',
            16: '4rem',
            18: '4.5rem',
            20: '5rem',
            22: '5.5rem',
            24: '6rem',
            26: '6.5rem',
            28: '7rem',
            30: '7.5rem',
            32: '8rem',
            36: '9rem',
            38: '9.5rem',
            40: '10rem',
            44: '11rem',
            48: '12rem',
            52: '13rem',
            56: '14rem',
            58: '14.5rem',
            60: '15rem',
            64: '16rem',
            72: '18rem',
            80: '20rem',
            90: '22.5rem',
            96: '24rem'
        },
        animation: {
            none: 'none',
            spin: 'spin 1s linear infinite',
            ping: 'ping 1s cubic-bezier(0, 0, 0.2, 1) infinite',
            pulse: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
            bounce: 'bounce 1s infinite'
        },
        aspectRatio: {
            auto: 'auto',
            square: '1 / 1',
            video: '16 / 9'
        },
        backdropBlur: function(param) {
            var theme = param.theme;
            return theme('blur');
        },
        backdropBrightness: function(param) {
            var theme = param.theme;
            return theme('brightness');
        },
        backdropContrast: function(param) {
            var theme = param.theme;
            return theme('contrast');
        },
        backdropGrayscale: function(param) {
            var theme = param.theme;
            return theme('grayscale');
        },
        backdropHueRotate: function(param) {
            var theme = param.theme;
            return theme('hueRotate');
        },
        backdropInvert: function(param) {
            var theme = param.theme;
            return theme('invert');
        },
        backdropOpacity: function(param) {
            var theme = param.theme;
            return theme('opacity');
        },
        backdropSaturate: function(param) {
            var theme = param.theme;
            return theme('saturate');
        },
        backdropSepia: function(param) {
            var theme = param.theme;
            return theme('sepia');
        },
        backgroundColor: function(param) {
            var theme = param.theme;
            return theme('colors');
        },
        backgroundImage: {
            none: 'none',
            'gradient-to-t': 'linear-gradient(to top, var(--tw-gradient-stops))',
            'gradient-to-tr': 'linear-gradient(to top right, var(--tw-gradient-stops))',
            'gradient-to-r': 'linear-gradient(to right, var(--tw-gradient-stops))',
            'gradient-to-br': 'linear-gradient(to bottom right, var(--tw-gradient-stops))',
            'gradient-to-b': 'linear-gradient(to bottom, var(--tw-gradient-stops))',
            'gradient-to-bl': 'linear-gradient(to bottom left, var(--tw-gradient-stops))',
            'gradient-to-l': 'linear-gradient(to left, var(--tw-gradient-stops))',
            'gradient-to-tl': 'linear-gradient(to top left, var(--tw-gradient-stops))'
        },
        backgroundOpacity: function(param) {
            var theme = param.theme;
            return theme('opacity');
        },
        backgroundPosition: {
            bottom: 'bottom',
            center: 'center',
            left: 'left',
            'left-bottom': 'left bottom',
            'left-top': 'left top',
            right: 'right',
            'right-bottom': 'right bottom',
            'right-top': 'right top',
            top: 'top'
        },
        backgroundSize: {
            auto: 'auto',
            cover: 'cover',
            contain: 'contain'
        },
        blur: {
            0: '0',
            none: '0',
            sm: '4px',
            DEFAULT: '8px',
            md: '12px',
            lg: '16px',
            xl: '24px',
            '2xl': '40px',
            '3xl': '64px'
        },
        brightness: {
            0: '0',
            50: '.5',
            75: '.75',
            90: '.9',
            95: '.95',
            100: '1',
            105: '1.05',
            110: '1.1',
            125: '1.25',
            150: '1.5',
            200: '2'
        },
        borderColor: function(param) {
            var theme = param.theme;
            return _objectSpread({}, theme('colors'), {
                DEFAULT: theme('colors.gray.200', 'currentColor')
            });
        },
        borderOpacity: function(param) {
            var theme = param.theme;
            return theme('opacity');
        },
        borderRadius: {
            none: '0px',
            sm: '0.125rem',
            DEFAULT: '0.25rem',
            md: '0.375rem',
            lg: '0.5rem',
            xl: '0.75rem',
            '2xl': '1rem',
            '3xl': '1.5rem',
            full: '9999px'
        },
        borderWidth: {
            DEFAULT: '1px',
            0: '0px',
            1.5: '1.5px',
            2: '2px',
            4: '4px',
            8: '8px'
        },
        boxShadow: {
            sm: '0 10px 20px 0 rgba(0, 0, 0, 0.1)',
            DEFAULT: '0 -5px 20px 0 rgb(0 0 0 / 10%)',
            md: '0 10px 20px 0 rgb(0 0 0 / 10%)',
            lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
            xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
            '2xl': '0 10px 20px 0 rgb(0 0 0 / 20%)',
            inner: 'inset 0 2px 4px 0 rgb(0 0 0 / 0.05)',
            none: 'none'
        },
        boxShadowColor: function(param) {
            var theme = param.theme;
            return theme('colors');
        },
        caretColor: function(param) {
            var theme = param.theme;
            return theme('colors');
        },
        accentColor: function(param) {
            var theme = param.theme;
            return _objectSpread({}, theme('colors'), {
                auto: 'auto'
            });
        },
        contrast: {
            0: '0',
            50: '.5',
            75: '.75',
            100: '1',
            125: '1.25',
            150: '1.5',
            200: '2'
        },
        container: {},
        content: {
            none: 'none'
        },
        cursor: {
            auto: 'auto',
            default: 'default',
            pointer: 'pointer',
            wait: 'wait',
            text: 'text',
            move: 'move',
            help: 'help',
            'not-allowed': 'not-allowed',
            none: 'none',
            'context-menu': 'context-menu',
            progress: 'progress',
            cell: 'cell',
            crosshair: 'crosshair',
            'vertical-text': 'vertical-text',
            alias: 'alias',
            copy: 'copy',
            'no-drop': 'no-drop',
            grab: 'grab',
            grabbing: 'grabbing',
            'all-scroll': 'all-scroll',
            'col-resize': 'col-resize',
            'row-resize': 'row-resize',
            'n-resize': 'n-resize',
            'e-resize': 'e-resize',
            's-resize': 's-resize',
            'w-resize': 'w-resize',
            'ne-resize': 'ne-resize',
            'nw-resize': 'nw-resize',
            'se-resize': 'se-resize',
            'sw-resize': 'sw-resize',
            'ew-resize': 'ew-resize',
            'ns-resize': 'ns-resize',
            'nesw-resize': 'nesw-resize',
            'nwse-resize': 'nwse-resize',
            'zoom-in': 'zoom-in',
            'zoom-out': 'zoom-out'
        },
        divideColor: function(param) {
            var theme = param.theme;
            return theme('borderColor');
        },
        divideOpacity: function(param) {
            var theme = param.theme;
            return theme('borderOpacity');
        },
        divideWidth: function(param) {
            var theme = param.theme;
            return theme('borderWidth');
        },
        dropShadow: {
            sm: '0 1px 1px rgb(0 0 0 / 0.05)',
            DEFAULT: [
                '0 1px 2px rgb(0 0 0 / 0.1)',
                '0 1px 1px rgb(0 0 0 / 0.06)'
            ],
            md: [
                '0 4px 3px rgb(0 0 0 / 0.07)',
                '0 2px 2px rgb(0 0 0 / 0.06)'
            ],
            lg: [
                '0 10px 8px rgb(0 0 0 / 0.04)',
                '0 4px 3px rgb(0 0 0 / 0.1)'
            ],
            xl: [
                '0 20px 13px rgb(0 0 0 / 0.03)',
                '0 8px 5px rgb(0 0 0 / 0.08)'
            ],
            '2xl': '0 25px 25px rgb(0 0 0 / 0.15)',
            none: '0 0 #0000'
        },
        fill: function(param) {
            var theme = param.theme;
            return theme('colors');
        },
        grayscale: {
            0: '0',
            DEFAULT: '100%'
        },
        hueRotate: {
            0: '0deg',
            15: '15deg',
            30: '30deg',
            60: '60deg',
            90: '90deg',
            180: '180deg'
        },
        invert: {
            0: '0',
            DEFAULT: '100%'
        },
        flex: {
            1: '1 1 0%',
            auto: '1 1 auto',
            initial: '0 1 auto',
            none: 'none'
        },
        flexBasis: function(param) {
            var theme = param.theme;
            return _objectSpread({
                auto: 'auto'
            }, theme('spacing'), {
                '1/2': '50%',
                '1/3': '33.333333%',
                '2/3': '66.666667%',
                '1/4': '25%',
                '2/4': '50%',
                '3/4': '75%',
                '1/5': '20%',
                '2/5': '40%',
                '3/5': '60%',
                '4/5': '80%',
                '1/6': '16.666667%',
                '2/6': '33.333333%',
                '3/6': '50%',
                '4/6': '66.666667%',
                '5/6': '83.333333%',
                '1/12': '8.333333%',
                '2/12': '16.666667%',
                '3/12': '25%',
                '4/12': '33.333333%',
                '5/12': '41.666667%',
                '6/12': '50%',
                '7/12': '58.333333%',
                '8/12': '66.666667%',
                '9/12': '75%',
                '10/12': '83.333333%',
                '11/12': '91.666667%',
                full: '100%'
            });
        },
        flexGrow: {
            0: '0',
            DEFAULT: '1'
        },
        flexShrink: {
            0: '0',
            DEFAULT: '1'
        },
        fontFamily: {
            sans: [
                '"Raleway"',
                'ui-sans-serif',
                'system-ui',
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                '"Noto Sans"',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
                '"Noto Color Emoji"', 
            ],
            serif: [
                '"Mr Dafoe"',
                'ui-serif',
                'Georgia',
                'Cambria',
                '"Times New Roman"',
                'Times',
                'serif', 
            ],
            mono: [
                'ui-monospace',
                'SFMono-Regular',
                'Menlo',
                'Monaco',
                'Consolas',
                '"Liberation Mono"',
                '"Courier New"',
                'monospace', 
            ]
        },
        fontSize: {
            xs: [
                '0.75rem',
                {
                    lineHeight: '1rem'
                }
            ],
            sm: [
                '0.875rem',
                {
                    lineHeight: '1.25rem'
                }
            ],
            md: [
                '0.9rem',
                {
                    lineHeight: '1.25rem'
                }
            ],
            base: [
                '1rem',
                {
                    lineHeight: '1.5rem'
                }
            ],
            lg: [
                '1.125rem',
                {
                    lineHeight: '1.75rem'
                }
            ],
            xl: [
                '1.25rem',
                {
                    lineHeight: '1.75rem'
                }
            ],
            '2xl': [
                '1.5rem',
                {
                    lineHeight: '2rem'
                }
            ],
            '3xl': [
                '1.875rem'
            ],
            '4xl': [
                '2rem',
                {
                    lineHeight: '2.5rem'
                }
            ],
            '5xl': [
                '3rem',
                {
                    lineHeight: '1'
                }
            ],
            '6xl': [
                '3.75rem',
                {
                    lineHeight: '1'
                }
            ],
            '7xl': [
                '4.5rem',
                {
                    lineHeight: '1'
                }
            ],
            '8xl': [
                '6rem',
                {
                    lineHeight: '1'
                }
            ],
            '9xl': [
                '8rem',
                {
                    lineHeight: '1'
                }
            ]
        },
        fontWeight: {
            thin: '100',
            extralight: '200',
            light: '300',
            normal: '400',
            medium: '500',
            semibold: '600',
            bold: '700',
            extrabold: '800',
            black: '900'
        },
        gap: function(param) {
            var theme = param.theme;
            return theme('spacing');
        },
        gradientColorStops: function(param) {
            var theme = param.theme;
            return theme('colors');
        },
        gridAutoColumns: {
            auto: 'auto',
            min: 'min-content',
            max: 'max-content',
            fr: 'minmax(0, 1fr)'
        },
        gridAutoRows: {
            auto: 'auto',
            min: 'min-content',
            max: 'max-content',
            fr: 'minmax(0, 1fr)'
        },
        gridColumn: {
            auto: 'auto',
            'span-1': 'span 1 / span 1',
            'span-2': 'span 2 / span 2',
            'span-3': 'span 3 / span 3',
            'span-4': 'span 4 / span 4',
            'span-5': 'span 5 / span 5',
            'span-6': 'span 6 / span 6',
            'span-7': 'span 7 / span 7',
            'span-8': 'span 8 / span 8',
            'span-9': 'span 9 / span 9',
            'span-10': 'span 10 / span 10',
            'span-11': 'span 11 / span 11',
            'span-12': 'span 12 / span 12',
            'span-full': '1 / -1'
        },
        gridColumnEnd: {
            auto: 'auto',
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            10: '10',
            11: '11',
            12: '12',
            13: '13'
        },
        gridColumnStart: {
            auto: 'auto',
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            10: '10',
            11: '11',
            12: '12',
            13: '13'
        },
        gridRow: {
            auto: 'auto',
            'span-1': 'span 1 / span 1',
            'span-2': 'span 2 / span 2',
            'span-3': 'span 3 / span 3',
            'span-4': 'span 4 / span 4',
            'span-5': 'span 5 / span 5',
            'span-6': 'span 6 / span 6',
            'span-full': '1 / -1'
        },
        gridRowStart: {
            auto: 'auto',
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7'
        },
        gridRowEnd: {
            auto: 'auto',
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7'
        },
        gridTemplateColumns: {
            none: 'none',
            1: 'repeat(1, minmax(0, 1fr))',
            2: 'repeat(2, minmax(0, 1fr))',
            3: 'repeat(3, minmax(0, 1fr))',
            4: 'repeat(4, minmax(0, 1fr))',
            5: 'repeat(5, minmax(0, 1fr))',
            6: 'repeat(6, minmax(0, 1fr))',
            7: 'repeat(7, minmax(0, 1fr))',
            8: 'repeat(8, minmax(0, 1fr))',
            9: 'repeat(9, minmax(0, 1fr))',
            10: 'repeat(10, minmax(0, 1fr))',
            11: 'repeat(11, minmax(0, 1fr))',
            12: 'repeat(12, minmax(0, 1fr))'
        },
        gridTemplateRows: {
            none: 'none',
            1: 'repeat(1, minmax(0, 1fr))',
            2: 'repeat(2, minmax(0, 1fr))',
            3: 'repeat(3, minmax(0, 1fr))',
            4: 'repeat(4, minmax(0, 1fr))',
            5: 'repeat(5, minmax(0, 1fr))',
            6: 'repeat(6, minmax(0, 1fr))'
        },
        height: function(param) {
            var theme = param.theme;
            return _objectSpread({
                auto: 'auto'
            }, theme('spacing'), {
                '1/2': '50%',
                '1/3': '33.333333%',
                '2/3': '66.666667%',
                '1/4': '25%',
                '2/4': '50%',
                '3/4': '75%',
                '1/5': '20%',
                '2/5': '40%',
                '3/5': '60%',
                '4/5': '80%',
                '1/6': '16.666667%',
                '2/6': '33.333333%',
                '3/6': '50%',
                '4/6': '66.666667%',
                '5/6': '83.333333%',
                full: '100%',
                screen: '100vh',
                min: 'min-content',
                max: 'max-content',
                fit: 'fit-content',
                'slider-item': '300px',
                'slider-item-lg': '340px'
            });
        },
        inset: function(param) {
            var theme = param.theme;
            return _objectSpread({
                auto: 'auto'
            }, theme('spacing'), {
                '1/2': '50%',
                '1/3': '33.333333%',
                '2/3': '66.666667%',
                '1/4': '25%',
                '2/4': '50%',
                '3/4': '75%',
                full: '100%'
            });
        },
        keyframes: {
            spin: {
                to: {
                    transform: 'rotate(360deg)'
                }
            },
            ping: {
                '75%, 100%': {
                    transform: 'scale(2)',
                    opacity: '0'
                }
            },
            pulse: {
                '50%': {
                    opacity: '.5'
                }
            },
            bounce: {
                '0%, 100%': {
                    transform: 'translateY(-25%)',
                    animationTimingFunction: 'cubic-bezier(0.8,0,1,1)'
                },
                '50%': {
                    transform: 'none',
                    animationTimingFunction: 'cubic-bezier(0,0,0.2,1)'
                }
            }
        },
        letterSpacing: {
            tighter: '-0.05em',
            tight: '-0.025em',
            normal: '0em',
            wide: '0.025em',
            wider: '0.05em',
            widest: '0.1em'
        },
        lineHeight: {
            none: '1',
            tight: '1.25',
            snug: '1.375',
            normal: '1.5',
            relaxed: '1.625',
            loose: '2',
            3: '.75rem',
            4: '1rem',
            5: '1.25rem',
            6: '1.5rem',
            7: '1.75rem',
            8: '2rem',
            9: '2.25rem',
            10: '2.5rem',
            11: '2.75rem'
        },
        listStyleType: {
            none: 'none',
            disc: 'disc',
            decimal: 'decimal'
        },
        margin: function(param) {
            var theme = param.theme;
            return _objectSpread({
                auto: 'auto',
                header: '51px'
            }, theme('spacing'));
        },
        maxHeight: function(param) {
            var theme = param.theme;
            return _objectSpread({}, theme('spacing'), {
                full: '100%',
                screen: '100vh',
                min: 'min-content',
                max: 'max-content',
                fit: 'fit-content'
            });
        },
        maxWidth: function(param) {
            var theme = param.theme, breakpoints = param.breakpoints;
            return _objectSpread({
                none: 'none',
                0: '0rem',
                xs: '20rem',
                sm: '24rem',
                md: '28rem',
                lg: '32rem',
                xl: '36rem',
                '2xl': '42rem',
                '3xl': '48rem',
                '4xl': '56rem',
                '5xl': '64rem',
                '6xl': '72rem',
                '7xl': '80rem',
                '8xl': '90rem',
                '9xl': '94rem',
                full: '100%',
                min: 'min-content',
                max: 'max-content',
                fit: 'fit-content',
                prose: '65ch'
            }, breakpoints(theme('screens')));
        },
        minHeight: {
            0: '0px',
            full: '100%',
            screen: '100vh',
            min: 'min-content',
            max: 'max-content',
            fit: 'fit-content'
        },
        minWidth: {
            0: '0px',
            full: '100%',
            min: 'min-content',
            max: 'max-content',
            fit: 'fit-content'
        },
        objectPosition: {
            bottom: 'bottom',
            center: 'center',
            left: 'left',
            'left-bottom': 'left bottom',
            'left-top': 'left top',
            right: 'right',
            'right-bottom': 'right bottom',
            'right-top': 'right top',
            top: 'top'
        },
        opacity: {
            0: '0',
            5: '0.05',
            10: '0.1',
            20: '0.2',
            25: '0.25',
            30: '0.3',
            40: '0.4',
            50: '0.5',
            60: '0.6',
            70: '0.7',
            75: '0.75',
            80: '0.8',
            90: '0.9',
            95: '0.95',
            100: '1'
        },
        order: {
            first: '-9999',
            last: '9999',
            none: '0',
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            10: '10',
            11: '11',
            12: '12'
        },
        padding: function(param) {
            var theme = param.theme;
            return theme('spacing');
        },
        placeholderColor: function(param) {
            var theme = param.theme;
            return theme('colors');
        },
        placeholderOpacity: function(param) {
            var theme = param.theme;
            return theme('opacity');
        },
        outlineColor: function(param) {
            var theme = param.theme;
            return theme('colors');
        },
        outlineOffset: {
            0: '0px',
            1: '1px',
            2: '2px',
            4: '4px',
            8: '8px'
        },
        outlineWidth: {
            0: '0px',
            1: '1px',
            2: '2px',
            4: '4px',
            8: '8px'
        },
        ringColor: function(param) {
            var theme = param.theme;
            return _objectSpread({
                DEFAULT: theme('colors.blue.500', '#3b82f6')
            }, theme('colors'));
        },
        ringOffsetColor: function(param) {
            var theme = param.theme;
            return theme('colors');
        },
        ringOffsetWidth: {
            0: '0px',
            1: '1px',
            2: '2px',
            4: '4px',
            8: '8px'
        },
        ringOpacity: function(param) {
            var theme = param.theme;
            return _objectSpread({
                DEFAULT: '0.5'
            }, theme('opacity'));
        },
        ringWidth: {
            DEFAULT: '3px',
            0: '0px',
            1: '1px',
            2: '2px',
            4: '4px',
            8: '8px'
        },
        rotate: {
            0: '0deg',
            1: '1deg',
            2: '2deg',
            3: '3deg',
            6: '6deg',
            12: '12deg',
            45: '45deg',
            90: '90deg',
            180: '180deg'
        },
        saturate: {
            0: '0',
            50: '.5',
            100: '1',
            150: '1.5',
            200: '2'
        },
        scale: {
            0: '0',
            50: '.5',
            75: '.75',
            90: '.9',
            95: '.95',
            100: '1',
            105: '1.05',
            110: '1.1',
            125: '1.25',
            150: '1.5'
        },
        scrollMargin: function(param) {
            var theme = param.theme;
            return _objectSpread({}, theme('spacing'));
        },
        scrollPadding: function(param) {
            var theme = param.theme;
            return theme('spacing');
        },
        sepia: {
            0: '0',
            DEFAULT: '100%'
        },
        skew: {
            0: '0deg',
            1: '1deg',
            2: '2deg',
            3: '3deg',
            6: '6deg',
            12: '12deg'
        },
        space: function(param) {
            var theme = param.theme;
            return _objectSpread({}, theme('spacing'));
        },
        stroke: function(param) {
            var theme = param.theme;
            return theme('colors');
        },
        strokeWidth: {
            0: '0',
            1: '1',
            2: '2'
        },
        textColor: function(param) {
            var theme = param.theme;
            return theme('colors');
        },
        textDecorationColor: function(param) {
            var theme = param.theme;
            return theme('colors');
        },
        textDecorationThickness: {
            auto: 'auto',
            'from-font': 'from-font',
            0: '0px',
            1: '1px',
            2: '2px',
            4: '4px',
            8: '8px'
        },
        textUnderlineOffset: {
            auto: 'auto',
            0: '0px',
            1: '1px',
            2: '2px',
            4: '4px',
            8: '8px'
        },
        textIndent: function(param) {
            var theme = param.theme;
            return _objectSpread({}, theme('spacing'));
        },
        textOpacity: function(param) {
            var theme = param.theme;
            return theme('opacity');
        },
        transformOrigin: {
            center: 'center',
            top: 'top',
            'top-right': 'top right',
            right: 'right',
            'bottom-right': 'bottom right',
            bottom: 'bottom',
            'bottom-left': 'bottom left',
            left: 'left',
            'top-left': 'top left'
        },
        transitionDelay: {
            75: '75ms',
            100: '100ms',
            150: '150ms',
            200: '200ms',
            300: '300ms',
            500: '500ms',
            700: '700ms',
            1000: '1000ms'
        },
        transitionDuration: {
            DEFAULT: '150ms',
            75: '75ms',
            100: '100ms',
            150: '150ms',
            200: '200ms',
            300: '300ms',
            500: '500ms',
            700: '700ms',
            1000: '1000ms'
        },
        transitionProperty: {
            none: 'none',
            all: 'all',
            DEFAULT: 'color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter',
            colors: 'color, background-color, border-color, text-decoration-color, fill, stroke',
            opacity: 'opacity',
            shadow: 'box-shadow',
            transform: 'transform'
        },
        transitionTimingFunction: {
            DEFAULT: 'cubic-bezier(0.4, 0, 0.2, 1)',
            linear: 'linear',
            in: 'cubic-bezier(0.4, 0, 1, 1)',
            out: 'cubic-bezier(0, 0, 0.2, 1)',
            'in-out': 'cubic-bezier(0.4, 0, 0.2, 1)'
        },
        translate: function(param) {
            var theme = param.theme;
            return _objectSpread({}, theme('spacing'), {
                '1/2': '50%',
                '1/3': '33.333333%',
                '2/3': '66.666667%',
                '1/4': '25%',
                '2/4': '50%',
                '3/4': '75%',
                full: '100%'
            });
        },
        width: function(param) {
            var theme = param.theme;
            return _objectSpread({
                auto: 'auto'
            }, theme('spacing'), {
                '1/2': '50%',
                '1/3': '33.333333%',
                '2/3': '66.666667%',
                '1/4': '25%',
                '2/4': '50%',
                '3/4': '75%',
                '1/5': '20%',
                '2/5': '40%',
                '3/5': '60%',
                '4/5': '80%',
                '1/6': '16.666667%',
                '2/6': '33.333333%',
                '3/6': '50%',
                '4/6': '66.666667%',
                '5/6': '83.333333%',
                '1/12': '8.333333%',
                '2/12': '16.666667%',
                '3/12': '25%',
                '4/12': '33.333333%',
                '5/12': '41.666667%',
                '6/12': '50%',
                '7/12': '58.333333%',
                '8/12': '66.666667%',
                '9/12': '75%',
                '10/12': '83.333333%',
                '11/12': '91.666667%',
                full: '100%',
                screen: '100vw',
                min: 'min-content',
                max: 'max-content',
                fit: 'fit-content',
                'slider-item': '280px',
                'slider-item-lg': '360px'
            });
        },
        willChange: {
            auto: 'auto',
            scroll: 'scroll-position',
            contents: 'contents',
            transform: 'transform'
        },
        zIndex: {
            auto: 'auto',
            0: '0',
            10: '10',
            20: '20',
            30: '30',
            40: '40',
            50: '50'
        },
        typography: function(theme) {
            return {
                DEFAULT: {
                    css: {
                        // color: theme('colors.primary.700'),
                        lineHeight: theme('lineHeight.7'),
                        a: {
                            color: theme('colors.primary.600'),
                            fontWeight: theme('fontWeight.semibold'),
                            textDecoration: 'underline'
                        },
                        'a:hover': {
                            color: theme('colors.action.800')
                        },
                        p: {
                            marginBottom: theme('spacing.3')
                        },
                        ul: {
                            marginBottom: theme('spacing.3')
                        },
                        ol: {
                            marginBottom: theme('spacing.3')
                        },
                        'h3, h3 a': {
                            color: theme('colors.primary.600'),
                            fontSize: theme('fontSize.xl'),
                            fontWeight: theme('fontWeight.semibold'),
                            marginBottom: theme('spacing.2')
                        },
                        'h4, h4 a': {
                            color: theme('colors.primary.600'),
                            fontSize: theme('fontSize.lg'),
                            fontWeight: theme('fontWeight.semibold'),
                            marginBottom: theme('spacing.2')
                        }
                    }
                }
            };
        }
    },
    variantOrder: [
        'first',
        'last',
        'odd',
        'even',
        'visited',
        'checked',
        'empty',
        'read-only',
        'group-hover',
        'group-focus',
        'focus-within',
        'hover',
        'focus',
        'focus-visible',
        'active',
        'disabled', 
    ],
    corePlugins: {
        aspectRatio: false
    },
    plugins: [
        __webpack_require__(54863),
        __webpack_require__(50130)({
            strategy: 'class'
        }),
        __webpack_require__(64221),
        __webpack_require__(34270), 
    ]
};


/***/ })

}]);